import { render, staticRenderFns } from "./KabLogo.vue?vue&type=template&id=b91f8124&"
import script from "./KabLogo.vue?vue&type=script&lang=js&"
export * from "./KabLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports